/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */
import 'altcha';
import '../scss/front.scss';

/**
 * Import modules / classes
 */
import InjectSvgImages from './modules/InjectSvgImages';
import Navigation from './modules/Navigation';
import Tabs from './modules/Tabs';
import HeroSlider from './modules/HeroSlider';
import CoursesSlider from './modules/CoursesSlider';
import TabsCategoriesSlider from './modules/TabsCategoriesSlider';
import ReviewsSlider from './modules/ReviewsSlider';
import CategoriesSlider from './modules/CategoriesSlider';
import Newsletter from './modules/Newsletter';
import NewsletterPopup from './modules/NewsletterPopup';
import Accordion from './modules/Accordion';

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener('DOMContentLoaded', () => {
    const myInjectSvgImages = new InjectSvgImages();
    const myNavigation = new Navigation();
    const myTabs = new Tabs('jsFpCategoriesTabs');
    const myHeroSlider = new HeroSlider();
    const myCoursesSlider = new CoursesSlider();
    const myTabsCategoriesSlider = new TabsCategoriesSlider();
    const myReviewsSlider = new ReviewsSlider();
    const myCategoriesSlider = new CategoriesSlider();
    const myNewsletter = new Newsletter();
    const myNewsletterPopup = new NewsletterPopup();

    const flexibleBlockAccordions = [
        ...document.querySelectorAll('.jsFlexibleBlockAccordion'),
    ];

    if (flexibleBlockAccordions.length) {
        flexibleBlockAccordions.forEach((flexibleAccordion) => {
            const myTrainigScopeAccordion = new Accordion(flexibleAccordion, {
                allowOpeningAll: true,
            });
        });
    }

    const kfsPowiatyAccordions = [
        ...document.querySelectorAll('.jsKfsPowiatyAccordion'),
    ];

    if (kfsPowiatyAccordions.length) {
        kfsPowiatyAccordions.forEach((accordion) => {
            new Accordion(accordion, {
                allowOpeningAll: true,
            });
        });
    }

    // KFS Powiaty Search Filter
    const kfsPowiatySearch = document.querySelector('.jsKfsPowiatySearch');
    const kfsPowiatyClearBtn = document.querySelector(
        '.jsKfsPowiatySearchClear',
    );
    const kfsPowiatyNoResults = document.querySelector(
        '.jsKfsPowiatyNoResults',
    );
    const kfsPowiatyAccordionItems = document.querySelectorAll(
        '.kfs-powiaty__accordion__item',
    );

    if (kfsPowiatySearch && kfsPowiatyAccordionItems.length) {
        let debounceTimer;

        const filterPowiaty = (searchTerm) => {
            const term = searchTerm.toLowerCase().trim();
            let totalMatches = 0;

            kfsPowiatyAccordionItems.forEach((item) => {
                const rows = item.querySelectorAll('tbody tr');
                let itemHasMatch = false;

                rows.forEach((row) => {
                    const name = row.dataset.nazwaPup || '';

                    if (term === '' || name.includes(term)) {
                        row.style.display = '';
                        itemHasMatch = true;
                    } else {
                        row.style.display = 'none';
                    }
                });

                item.style.display = itemHasMatch ? '' : 'none';
                if (itemHasMatch) totalMatches++;
            });

            // Show/hide no results message
            if (kfsPowiatyNoResults) {
                kfsPowiatyNoResults.classList.toggle(
                    'is-visible',
                    term !== '' && totalMatches === 0,
                );
            }

            // Show/hide clear button
            if (kfsPowiatyClearBtn) {
                kfsPowiatyClearBtn.classList.toggle('is-visible', term !== '');
            }
        };

        kfsPowiatySearch.addEventListener('input', (e) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                filterPowiaty(e.target.value);
            }, 150);
        });

        // Clear button handler
        if (kfsPowiatyClearBtn) {
            kfsPowiatyClearBtn.addEventListener('click', () => {
                kfsPowiatySearch.value = '';
                filterPowiaty('');
                kfsPowiatySearch.focus();
            });
        }
    }
});
